import { Box, Divider, MenuItem, TextField, Typography } from '@mui/material';
import ConditionCriteriaFields from './ConditionCriteriaFields';

const BRANCHES = [
  { branch: 'yes', field: 'yesAction', label: 'Ja-Zweig (Bedingung erfüllt)' },
  { branch: 'no', field: 'noAction', label: 'Nein-Zweig (Bedingung nicht erfüllt)' },
];

// Settings for the "Bedingter Split": the shared criteria plus what each of the
// two branches does. The condition is evaluated the moment a contact reaches the
// block; the contact then continues along the matching branch only.
const ConditionalSplitSettings = ({ block, blocks = [], readOnly, onConfigChange }) => {
  const config = block.config || {};

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <ConditionCriteriaFields
        block={block}
        blocks={blocks}
        readOnly={readOnly}
        onConfigChange={onConfigChange}
      />
      <Divider />
      <Typography variant='subtitle2'>Verzweigung</Typography>
      {BRANCHES.map(entry => (
        <TextField
          key={entry.field}
          select
          size='small'
          label={entry.label}
          value={config[entry.field] === 'exit' ? 'exit' : 'continue'}
          disabled={readOnly}
          onChange={event => onConfigChange({ [entry.field]: event.target.value })}
        >
          <MenuItem value='continue'>Weiter am Ausgang „{entry.branch === 'yes' ? 'Ja' : 'Nein'}“</MenuItem>
          <MenuItem value='exit'>Flow für den Kontakt beenden</MenuItem>
        </TextField>
      ))}
      <Typography variant='caption' color='text.secondary'>
        Der Block prüft die Bedingung in dem Moment, in dem der Kontakt ihn erreicht, und schickt ihn
        dann nur über den passenden Ausgang weiter. Ein Zweig ohne Verbindung beendet den Flow
        genauso wie „Flow beenden“ — so fliegt z. B. jeder, der den Gutschein schon eingelöst hat,
        aus dem Flow und bekommt keinen Reminder mehr.
      </Typography>
    </Box>
  );
};

export default ConditionalSplitSettings;
